import { useQuery, QueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";

const queryClient = new QueryClient();

const fetchOriginalOutcome = async () => {
  try {
    //* return from TanStack Query Cache.
    const requestResponse = queryClient.getQueryData([
      queryKeys.ORIGINAL_AURA_OUTCOME,
    ]);

    return requestResponse || {};
  } catch (ex) {
    console.error(ex);
    return {};
  }
};

export const useOriginalAuraOutcome = (enabled = false) =>
  useQuery({
    queryKey: [queryKeys.ORIGINAL_AURA_OUTCOME],
    queryFn: async () => await fetchOriginalOutcome(),
    staleTime: Infinity,
    enable: enabled,
  });
